import { z } from "zod"
import { createDeviceStorageItem } from "@/shared/lib/storage"
import { InstallReferrer } from "./plugin"

const PLUGIN_TIMEOUT_MS = 5000

// Сырая строка Install Referrer. RuStore SDK 10.x может отдать значение только
// один раз, а нужно оно двум фичам (install-attribution и invite-friend) в
// разные моменты — поэтому храним на устройстве и не удаляем.
const stored = createDeviceStorageItem<string | null>({
	key: "install-referrer",
	schema: z.string().nullable(),
	fallback: null,
})

let inFlight: Promise<string> | null = null

function withTimeout<T>(promise: Promise<T>, ms: number): Promise<T> {
	return Promise.race([
		promise,
		new Promise<never>((_, reject) =>
			setTimeout(
				() =>
					reject(
						Object.assign(new Error("InstallReferrer timeout"), {
							code: "TIMEOUT",
						}),
					),
				ms,
			),
		),
	])
}

/**
 * Строка вида "tg_ref_code=abc&utm_source=x". Плагин спрашивается не больше
 * одного раза одновременно и только пока строки нет в хранилище. Ошибки плагина
 * пробрасываются как есть (с `code`); зависший SDK — ошибка с кодом `TIMEOUT`.
 */
export function readInstallReferrer(): Promise<string> {
	const cached = stored.get()
	if (cached !== null) return Promise.resolve(cached)

	// Кешируем по самому плагину, а не по гонке с таймаутом: одноразовая
	// строка RuStore, пришедшая позже таймаута, не должна пропасть.
	inFlight ??= InstallReferrer.getReferrerDetails()
		.then(({ referrerUrl }) => {
			const value = referrerUrl ?? ""
			stored.set(value)
			return value
		})
		.finally(() => {
			inFlight = null
		})
	return withTimeout(inFlight, PLUGIN_TIMEOUT_MS)
}
